
import './App.css';
import Form from './Form';
import logo from './Assets/logo.png';
function App() {
  return (
    <div className="container">
       <img src={logo} alt="" className="logo" />
      <p className='email'>Contact us : ManaheijDev@gmail.com</p>
      <p className='email'>whatsApp : +201009389310</p>
      <Form />
    </div>
  );
}

export default App;
